import { render, staticRenderFns } from "./SubscribersIndex.vue?vue&type=template&id=f605ae24&scoped=true"
import script from "./SubscribersIndex.vue?vue&type=script&lang=ts"
export * from "./SubscribersIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f605ae24",
  null
  
)

export default component.exports